import { createSlice } from "@reduxjs/toolkit";

import {
  BUYER,
  GUEST,
  ROLE_BUYER,
  ROLE_CONSULTANT,
  ROLE_C_ADMIN,
  ROLE_GUEST,
  ROLE_SELLER,
  SELLER,
} from "../../../Utils/constant";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  employeeForEdit: {
    id: undefined,
    email: "",
    role: "",
    phone: "",
    userOrg: null,
    isUserVerified: false,
  },
  message: null,
  messageType: null,
  showMessage: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const employeeSlice = createSlice({
  name: "employee",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // location loader
    employeeListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    employeeList: (state, action) => {
      const { result, count, user } = action.payload;

      let tempArray = [];

      result.forEach(item => {
        var org = item.userOrg.find(
          x => x.organization?.id === user.currentOrganization?.id,
        );
        var tempRole;

        if (org) {
          if (org.roles && org.roles.length > 0) {
            if (org.roles.findIndex(val => val?.key === ROLE_C_ADMIN) > -1)
              tempRole = "Company Admin";
            else if (
              org.roles.findIndex(val => val?.key === ROLE_BUYER) > -1 &&
              org.roles.findIndex(val => val?.key === ROLE_SELLER) > -1
            )
              tempRole = SELLER;
            else if (org.roles.findIndex(val => val?.key === ROLE_SELLER) > -1)
              tempRole = SELLER;
            else if (org.roles.findIndex(val => val?.key === ROLE_BUYER) > -1)
              tempRole = BUYER;
            else if (org.roles.findIndex(val => val?.key === ROLE_GUEST) > -1)
              tempRole = GUEST;
            else if (
              org.roles.findIndex(val => val?.key === ROLE_CONSULTANT) > -1
            )
              tempRole = "Consultant";
          } else tempRole = item.roles[0].role;
        } else tempRole = item.roles[0].role;
        if (!item.isDeleted) {
          let tempObj = {
            id: item.id,
            name: item.displayName,
            email: item.email,
            role: tempRole,
            phone: item.phoneno,
            isUserVerified: item.isUserVerified,
            userOrg: item.userOrg,
            isForceResetPassword: item.isForceResetPassword,
            isActive: item.isActive,
            isInvited: item.isInvited,
            isDeleted: item.isDeleted,
          };

          tempArray.push(tempObj);
        }
      });

      state.totalCount = count;
      state.entities = tempArray;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadEmployeeForEdit: (state, action) => {
      if (!action.payload.isDeleted) {
        let temp = {
          id: action.payload.id,
          first_name: action.payload.firstName,
          last_name: action.payload.lastName,
          email: action.payload.email,
          role: action.payload.roles[0].role,
          isForceResetPassword: action.payload.isForceResetPassword,
          isActive: action.payload.isActive,
          isEmailVarified: action.payload.isEmailVarified,
          isApproved: action.payload.isApproved,
          isUserVerified: action.payload.isUserVerified,
          isDeleted: action.payload.isDeleted,
          display_name: action.payload.displayName,
          phone: action.payload.phoneno,
          createdAt: action.payload.createdAt,
          userOrg: action.payload.userOrg,
        };

        state.employeeForEdit = temp;
      }
    },
    loadEmployeeMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
  },
});
